import FragmentFullContent from "./FragmentFullContent";
import { getImagesUrl } from "../../redux/common";
import { Card, CardContent, CardMedia, Typography } from "@mui/material";

export function ElementNotAuthenticated() {
    const item = {
            image: `${getImagesUrl()}/not-authenticated.webp`,
            title: "Não autenticado",
            description: <>
                <div>Por favor, faça o login.</div>
            </>
        };
    return <>
    <FragmentFullContent>
        <Card sx={{ display: "flex", m: 1 }} elevation={3}>
        <CardMedia component="img" sx={{ width: { xs: 80, sm: 160 } }} image={item.image} />
        <CardContent sx={{ flex: 1 }}>
            <Typography component="h2" variant="h5">
                {item.title}
            </Typography>
            <Typography variant="subtitle2">
                {item.description}
            </Typography>
        </CardContent>
        </Card>
    </FragmentFullContent>
</>;
}